import api from "../config/api";

export const fetchOrder = async () => {
    const res = await api.get(`/order/?flag=allOrders`)
    return res.data.data;
}
export const fetchOrdersById = async (id) => {
    const res = await api.get(`/order/?id=${id}`)
    return res.data.data;
}
export const fetchOrdersByCustomerId = async (customerId) => {
    const res = await api.get(`/order/?customerId=${customerId}`)
    return res.data.data;
}
export const createOrder = async (FormData) => {
    const res = await api.post(`/order/`, FormData)
    return res.data;
}

export const updateOrder = async (id, data) => {
    const res = await api.post(`/order/?id=${id}`, data)
    return res.data.data;
}

export const updateOrderStatus = async (FormData) => {
    console.log('form', FormData);

    const res = await api.post(`/order/?flag=updateStatus`, FormData)
    return res.data.data;
}

export const deleteOrder = async (id) => {
    const res = await api.delete(`/order/?id=${id}`)
    return res.data.data
}